import { useEffect, useState } from "react";
import useMotionPreferences from "@/hooks/useMotionPreferences";

export default function TypewriterText({
  text = "",
  speed = 34,
  className = "",
}) {
  const { prefersReducedMotion } = useMotionPreferences();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(prefersReducedMotion ? text.length : 0);
  }, [prefersReducedMotion, text]);

  useEffect(() => {
    if (prefersReducedMotion) return undefined;
    if (!text || index >= text.length) return undefined;
    const t = setTimeout(() => setIndex((n) => n + 1), speed);
    return () => clearTimeout(t);
  }, [index, prefersReducedMotion, speed, text]);

  return (
    <span className={className}>
      {text.slice(0, index)}
      {!prefersReducedMotion && index < text.length && (
        <span className="ml-0.5 inline-block h-[1em] w-[1px] animate-pulse bg-current align-middle" />
      )}
    </span>
  );
}
